import { AiMoodBackdrop } from './AiMoodBackdrop';

/** Full-intensity mood backdrop — matches LandingPage. */
export function LandingBackdrop() {
  return <AiMoodBackdrop variant="full" className="-z-10" />;
}
